import React from "react"
import { FormGroup, Input, Label } from "reactstrap"

export interface RadioButtonOption {
    text?: string
    value: string | number
}

interface Props {
    name: string
    options: RadioButtonOption[]
    value: string | number
    onChange: ({ target }: React.ChangeEvent<HTMLInputElement>) => void
}

export class RadioButtons extends React.Component<Props> {
    render () {
        return this.props.options.map((option) => {
            const text = option.text ? option.text : option.value
            return (
                <FormGroup check key={option.value}>
                    <Label check>
                        <Input
                            type="radio"
                            name={this.props.name}
                            value={option.value}
                            checked={this.props.value === option.value}
                            onChange={this.props.onChange}
                        />
                        {' '} {text}
                    </Label>
                </FormGroup>
            )
        })
    }
}
